import getClassNameReduxUtil from '../get-class-name'
import { getIdReduxUtil } from '../get-id'
import { getValueReduxUtil } from '../get-value'

function createPointerReduxUtil (instance, properties) {
  if (!instance) {
    return instance
  }
  if (!Array.isArray(properties)) {
    properties = []
  }
  return {
    className: getClassNameReduxUtil(instance),
    data: {
      id: getIdReduxUtil(instance),
      ...properties.reduce((obj, key) => {
        obj[key] = getValueReduxUtil(instance, key)
        return obj
      }, {})
    }
  }
}

export default createPointerReduxUtil
